import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
// import Button from "components/CustomButtons/Button.js";
import { Button, Grid } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import ToastModal from "views/components/ToastModal";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { toCamelCase } from "utils/Utils";
import { formatAmount } from "utils/Utils";
import { formatTimestamp } from "utils/Utils";
import { parseDateMDY } from "utils/Utils";
import { parseAndSetFlag } from "utils/Utils";

const Repayment = ({classes}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { authToken } = useSelector((state) => state.login.authData);
  const { mobileNumber } = useSelector((state) => state.login.userData);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    { id: "leadid", label: "Serial No." },
    { id: "created", label: "Created By" },
    { id: "createdOn", label: "Created On" },
    { id: "accountNumber", label: "Loan Account Number" },
    { id: "customerid", label: "Customer Id" },
    { id: "maxEligibleLoanAmount", label: "Max Eligible Amount" },
    { id: "status", label: "Status" },
  ]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [callInProgress, setCallInProgress] = useState(false);
  const repaymentFlag = sessionStorage.getItem("RepaymentFlag");
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
      getUserLoanDetails();
  },[])

  const getUserLoanDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_USER_LOAN_DETAILS_API + mobileNumber,
      authToken: authToken,
    });
    setCallInProgress(false);
    if(result?.data?.error_code === 401){
      toastUpdate("Error", result?.data?.user_description, true);
    }else{
      console.log(result?.data,"API DATA")
      parseIndicatorData(result?.data);
    }
  }
  const parseIndicatorData = (data) => {
    let reportData = [];
     data = data.filter(item => item.status === 'COMPLETED');

     data = data?.sort((a, b) => (a?.id < b?.id ? 1 : -1));
    data &&
      data?.forEach((leadDetails, index) => {
        let row = {
          leadid: index + 1,
          created: leadDetails?.createdBy,
          createdOn: parseDateMDY(leadDetails?.createdOn),
          accountNumber: leadDetails?.loanAccountNumber,
          customerid: leadDetails?.customerId,
          maxEligibleLoanAmount: formatAmount(leadDetails?.maxEligibleLoanAmount),
          status: toCamelCase(leadDetails?.status),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const onRowClick = async (data) => {
    console.log(data,"dafkjabdfjk")
    if(parseAndSetFlag(repaymentFlag)){
      navigate("/PayNow",{state: {loanNumber: data?.accountNumber }})
    }else{
      navigate("/repaymentDetails",{state: {loanNumber: data?.accountNumber }})
    }
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Active Loans"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={tableColumns} rows={selectedTableData} onRowClick={onRowClick}/>
      </Grid>
  {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
           {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

Repayment.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
};

export default Repayment;
